import { CIG } from "@lib/enums/generic";
import { api } from "@api/api";

export interface CIGProfilePartial {
  id: string;
  displayName: string;
  category: CIG;
  profilePictureURL: string;
  verified: boolean;
  accepted: boolean;
}

const getPendingCigs = async () => {
  const { data } = await api.post<Array<CIGProfilePartial>>("/adminGetCIGSPendingAcceptance");
  return data;
};

export default getPendingCigs;
